







































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { dictServe, institutionServer, performanceServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import ChoosePersonDialog from '@/views/inventoryManagement/unit/choosePersonDialog.vue';
import ChooseDeptOrPersonDialog from '@/views/inventoryManagement/unit/chooseDeptOrPersonDialog.vue';
import ChooseAuditDeptDialog from '@/views/inventoryManagement/unit/chooseAuditDeptDialog.vue';

@Component({
  components: { ChooseAuditDeptDialog, ChooseDeptOrPersonDialog, ChoosePersonDialog },
  mixins: [TableStripe],
})
export default class ChoiceCheckDialog extends Vue {
  private visible = false;
  fileList: any = [];
  deptObj: any = {}; // 子任务执行人员存储部门选中值
  postObj: any = []; // 子任务执行人员存储岗位选中值
  personObj: any = {}; // 子任务执行人员存储人员选中值

  deptSonObj: any = {}; // 子任务审核人员存储部门选中值
  postSonObj: any = []; // 子任务审核人员存储岗位选中值
  personSonObj: any = {}; // 子任务审核人员存储人员选中值
  isLoading: any = false; // 点击确定之后

  deptAuditDeptObj: any = {}; // 主任务审核部门/人存储部门选中值
  postAuditDeptObj: any = []; // 主任务审核部门/人存储岗位选中值
  personAuditDeptObj: any = {}; // 主任务审核部门/人存储人员选中值
  tasktTimeOptions: any = [];
  personData: any = [];
  timeArray: any = [];
  finishWayOptions: any = [
    {
      name: '同步完成',
    },
    {
      name: '独立完成',
    },
  ];

  newOptions: any = [
    {
      name: '固定',
    },
    {
      name: '动态',
    },
  ];
  headers: any = {};
  actionUrl: any = '';

  // 执行部门
  subSpaceByAuthOptions: any = [];

  // 回显执行部门
  spaceDeptByAuthOptions: any = [];

  // 职务
  spacePostByAuthOptions: any = [];

  // 任务
  taskOptions: any = [];
  newIdnex: any = '';
  newId: any = '';

  formData: any = {
    name: '',
    type: '',
    frequency: '',
    frequencyUnit: '',
    checkDepartment: '',
    remark: '',
    annex: '',
    checkDepartmentId: '',
    checkDepartmentName: '',
    checkStaffIds: '',
    childTaskList: [],
    finishWay: '',
    taskNature: '固定',
  };

  userRules: any = {
    // name: [{ required: true, trigger: 'blur', message: '请填写任务名称' }], // 任务名称
    // executeDepartmentId: [{ required: true, trigger: 'blur', message: '请选择执行部门' }], // 执行部门
    // type: [{ required: true, trigger: 'blur', message: '请选择任务类型' }], // 任务类型
    finishWay: [{ required: true, trigger: 'blur', message: '请选择完成方式' }], // 完成方式
    taskNature: [{ required: true, trigger: 'blur', message: '请选择任务性质' }], // 完成方式
  };

  private async showAddDialog(data: any) {
    await this.getSubSpaceByAuth();
    this.formData = {
      name: '',
      type: '',
      frequency: '',
      frequencyUnit: '',
      checkDepartment: '',
      remark: '',
      annex: '',
      checkDepartmentId: '',
      checkDepartmentName: '',
      checkStaffIds: '',
      childTaskList: [],
      finishWay: '',
      taskNature: '固定',
    };
    this.deptObj = {};
    this.postObj = [];
    this.personObj = {};
    this.deptSonObj = {};
    this.postSonObj = [];
    this.personSonObj = {};
    this.deptAuditDeptObj = {};
    this.postAuditDeptObj = [];
    this.personAuditDeptObj = {};
    this.newIdnex = '';
    await this.getDetailByIdData();
    await this.getTask();
    // 获取隐患详情数据
    await this.getDataById(data.id);
    this.newId = data.id;
    this.fileList = [];
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');

    this.visible = true;
  }

  /**
   * @desc 主任务审核部门/人弹窗中所选的数据
   * */
  getAuditDeptData(deptData: any, postData: any, personData: any) {
    this.deptAuditDeptObj = deptData;
    this.postAuditDeptObj = postData;
    this.personAuditDeptObj = personData;
    if (deptData.id && !personData.id) {
      this.formData.checkDepartmentId = deptData.id;
      this.formData.checkDepartmentName = deptData.name;
      this.formData.checkStaffIds = '';
      this.formData.checkDepartment = deptData.name;
    }
    if (deptData.id && personData.id) {
      this.formData.checkDepartmentId = deptData.id;
      this.formData.checkDepartmentName = deptData.name;
      this.formData.checkStaffIds = personData.id;
      this.formData.checkDepartment = personData.name;
    }
    if (!deptData.id && !personData.id) {
      this.formData.checkDepartmentId = '';
      this.formData.checkDepartmentName = '';
      this.formData.checkStaffIds = '';
      this.formData.checkDepartment = '';
    }
    this.$forceUpdate();
  }

  addChildTaskList() {
    this.formData.childTaskList.push({
      name: this.formData.dutyContent,
      executeStaffId: this.formData.executeStaffId,
      executeDepartmentId: this.formData.executeDepartmentId,
      person: this.formData.executeStaffName ? this.formData.executeStaffName : this.formData.executeDepartmentName,
      checkStaffIds: '',
      checkDeptId: '',
      checkPerson: '',
      time: this.timeArray[0],
    });
  }

  deleteChildTaskList(index: any) {
    this.formData.childTaskList.splice(index, 1);
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.spaceDeptByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  private async getDataById(id: any) {
    // 发起接口请求，获取分页数据
    performanceServer
      .getDutyRuleListDetail(id)
      .then(async (res: any) => {
        const newPerson: any = await this.getSpaceStaffByAuth(res.data.executeDepartmentId);
        const timeData: any = await this.getDutyRuleListCreateTaskBeforeTime(id);
        if (newPerson) {
          // console.log(res.data);
          const selectedDeptName = this.spaceDeptByAuthOptions.find((item: any) => {
            return item.id === res.data.executeDepartmentId;
          });
          this.deptObj = selectedDeptName;
          // setTimeout(() => {
          //   const selectedPersonName = this.personData.find((item: any) => {
          //     return item.id === res.data.executeStaffId;
          //   });
          //   this.personObj = selectedPersonName;

          if (res.data.frequency) {
            if (timeData) {
              for (let i = 0; i < res.data.frequency; i++) {
                const obj: any = {};
                obj.name = res.data.dutyContent;
                obj.executeStaffId = res.data.executeStaffId;
                obj.executeDepartmentId = res.data.executeDepartmentId;
                obj.person = res.data.executeStaffName ? res.data.executeStaffName : res.data.executeDepartmentName;
                obj.checkStaffIds = '';
                obj.checkDeptId = '';
                obj.checkPerson = '';
                obj.time = this.timeArray[i] ? this.timeArray[i] : [];
                this.formData.childTaskList.push(obj);
              }
            }

            console.log(this.formData.childTaskList, 'this.formData.childTaskList');
          }
          // }, 300);
        }

        this.formData.taskNature = res.data.taskNature ? res.data.taskNature : '固定';
        this.formData.dutyContent = res.data.dutyContent;
        this.formData.dutyMainPoint = res.data.dutyMainPoint;
        this.formData.type = res.data.type;
        this.formData.frequency = res.data.frequency;
        this.formData.frequencyUnit = res.data.frequencyUnit;
        this.formData.finishWay = res.data.finishWay;
        this.formData.remark = res.data.remark;
        this.formData.executeStaffId = res.data.executeStaffId;
        this.formData.executeDepartmentId = res.data.executeDepartmentId;
        this.formData.executeStaffName = res.data.executeStaffName;

        if (res.data.executeStaffId) {
          this.formData.name = res.data.executeStaffName;
        }
        if (res.data.executeDepartmentId && !res.data.executeStaffId) {
          this.formData.name = res.data.executeDepartmentName;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 选择主任务审核部门/人
  chooseAuditDeptLiable() {
    const chooseAuditDeptDialog = 'chooseAuditDeptDialog';
    const chooseAuditDeptDialogComponent = this.$refs[chooseAuditDeptDialog];
    (chooseAuditDeptDialogComponent as any).showDialog(this.deptAuditDeptObj, this.postAuditDeptObj, this.personAuditDeptObj); // 传给弹窗的数据 检查标准项(即 检查内容)
  }
  /**
   * @desc 选择子任务执行人触发回调
   * */
  getPersonData(deptData: any, postData: any, personData: any) {
    this.formData.childTaskList[this.newIdnex].executeDepartmentId = deptData.id;
    this.formData.childTaskList[this.newIdnex].executeStaffId = personData.id;
    this.formData.childTaskList[this.newIdnex].person = personData.name;
    this.$forceUpdate();
  }

  /**
   * @desc 选择子任务执行人打开弹框
   * */
  choosePersonLiable(data: any, index: any) {
    if (data.executeDepartmentId) {
      const selectedDeptName = this.spaceDeptByAuthOptions.find((item: any) => {
        return item.id === data.executeDepartmentId;
      });
      this.deptObj = selectedDeptName;
      const selectedPersonName = this.personData.find((item: any) => {
        return item.id === data.executeStaffId;
      });
      this.personObj = selectedPersonName;
    }
    this.newIdnex = index;
    const safetyDialog = 'choosePersonDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(this.deptObj, this.postObj, this.personObj); // 传给弹窗的数据
  }

  /**
   * @desc 选择子任务审核人或审核部门触发回调
   * */
  getDeptOrPersonData(deptData: any, postData: any, personData: any) {
    if (deptData.id && personData.id) {
      this.formData.childTaskList[this.newIdnex].checkDeptId = deptData.id;
      this.formData.childTaskList[this.newIdnex].checkStaffIds = personData.id;
      this.formData.childTaskList[this.newIdnex].checkPerson = personData.name;
    }
    if (deptData.id && !personData.id) {
      this.formData.childTaskList[this.newIdnex].checkDeptId = deptData.id;
      this.formData.childTaskList[this.newIdnex].checkStaffIds = '';
      this.formData.childTaskList[this.newIdnex].checkPerson = deptData.name;
    }
    if (!deptData.id && !personData.id) {
      this.formData.childTaskList[this.newIdnex].checkDeptId = '';
      this.formData.childTaskList[this.newIdnex].checkStaffIds = '';
      this.formData.childTaskList[this.newIdnex].checkPerson = '';
    }
    this.$forceUpdate();
  }

  /**
   * @desc 选择子任务审核人或审核部门打开弹框
   * */
  chooseDeptOrPersonLiable(data: any, index: any) {
    this.deptSonObj = {};
    this.personSonObj = {};
    this.postSonObj = [];
    if (data.checkDeptId) {
      const selectedDeptName = this.spaceDeptByAuthOptions.find((item: any) => {
        return item.id === data.checkDeptId;
      });
      this.deptSonObj = selectedDeptName;
      if (data.checkStaffIds) {
        const selectedPersonName = this.personData.find((item: any) => {
          return item.id === data.checkStaffIds;
        });
        this.personSonObj = selectedPersonName;
      } else {
        this.personSonObj = {};
      }
    }
    this.newIdnex = index;
    const safetyDialog = 'chooseDeptOrPersonDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(this.deptSonObj, this.postSonObj, this.personSonObj); // 传给弹窗的数据
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDetailByIdData() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('frequency')
      .then((res: any) => {
        for (const key in res.data) {
          this.tasktTimeOptions.push({
            value: key,
            label: res.data[key],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuth(id: any) {
    // 发起接口请求，获取分页数据
    const newData: any = new Promise(resolve => {
      userServe
        .getPageDataAll({
          // deptId: this.selectObj.id,
          // deptId: id,
          // postId: id,
        })
        .then((res: any) => {
          // console.log(res.data);
          this.personData = res.data;
          resolve(true);
          this.$forceUpdate();
        })
        .catch((error: any) => {
          this.$message.error('获取数据失败');
        });
    });
    return newData;
  }
  /**
   * @desc 创建任务前获取时间段
   */
  getDutyRuleListCreateTaskBeforeTime(id: any) {
    const newData: any = new Promise(resolve => {
      performanceServer
        .dutyRuleListCreateTaskBeforeTime(id)
        .then((res: any) => {
          this.timeArray = res.data;
          resolve(true);
          this.$forceUpdate();
        })
        .catch((error: any) => {
          this.$message.error('获取数据失败');
        });
    });
    return newData;
  }

  /**
   * @desc 获取任务类型数据
   * @param1 暂无
   * @returns 暂无
   */
  getTask() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('dutyTaskType')
      .then((res: any) => {
        for (const i in res.data) {
          this.taskOptions.push({
            value: i,
            label: res.data[i],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.fileList = [];
    this.visible = false;
  }

  /**
   @description: 数组去重
   @author: cxf
   @update: cxf 2021/7/26 16:20
   **/
  public unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].id === arr[j].id || arr[i].id === undefined || arr[j].id === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    this.isLoading = true;
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        this.isLoading = false;
        return;
      }
      this.addFunctionData();
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async addFunctionData() {
    const newList: any = [];
    this.formData.childTaskList.map((re: any) => {
      newList.push({
        checkDeptId: re.checkDeptId,
        checkStaffIds: re.checkStaffIds,
        executeStaffId: re.executeStaffId,
        startTime: re.time ? re.time[0] : '',
        endTime: re.time ? re.time[1] : '',
      });
    });
    const newObj: any = {
      annex: this.formData.annex,
      checkDepartmentId: this.formData.checkDepartmentId,
      checkDepartmentName: this.formData.checkDepartmentName,
      checkStaffIds: this.formData.checkStaffIds,
      finishWay: this.formData.finishWay,
      childTaskList: newList,
    };
    performanceServer
      .dutyRuleListCreateTask(newObj, this.newId)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('任务生成成功');
          this.isLoading = false;
          this.returnDialog(); // 返回到父级页面
          this.$emit('refreshData');
        } else {
          this.isLoading = false;
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('任务生成失败');
      });
  }

  private handleRemove(file: any, fileList: any) {
    const newArr: any = this.formData.annex.split(',');
    newArr.forEach((item: any, index: any) => {
      if (file.response) {
        if (item === file.response.data[0].id) {
          newArr.splice(index, 1);
        }
      } else {
        newArr.splice(index, 1);
      }
    });
    this.formData.annex = newArr.toString();
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    if (file.response.data) {
      const arr: any = [];
      fileList.forEach((item: any) => {
        if (item.response) {
          arr.push(item.response.data[0].id);
        } else {
          arr.push(item.name);
        }
      });
      this.formData.annex = arr.toString();
    } else {
      this.handleRemove1(file, '');
    }
  }

  private handleRemove1(file: any, fileList: any) {
    console.log(file);
  }
}
